import React, { useEffect, useMemo, useRef, useState } from "react";
import { Form, Formik } from "formik";
import editIcon from "../../Images/edit.svg";
import { create } from "../../DataApi/create";
import { useSession } from "../../authentications/SessionContext";
import { read } from "../../DataApi/read";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import LoaderWrapper from "../Loader/LoaderWrapper";
import { handleResponse } from "../../utilities/handleResponse";
import FormikInput from "../Formik/FormikInput";
import { write } from "../../DataApi/write";
import ErrorFocus from "../Formik/ErrorFocus";
import SVGButton from "../Buttons/SVGButton";
import cameraIcon from "../../Images/camera.svg";
import UploadedImage from "../UploadedImagedComponent/UploadedImage";
import { fileToBase64 } from "../../utilities/fileToBase64";
import useListOptions from "../../CustomHooks/useListOptions";
import useConfirmationModal from "../../Components/ConfirmationModal/useConfirmationModal";
import { FormContainer } from "../StyledComponents/FormConatiner/FormContainerStyle";
import { findAndAddOption } from "../../utilities/findAndAddOption";
import useFormikSubmitButton from "../../CustomHooks/useFormikSubmitButton";
import { nameCreateGeneral } from "../../DataApi/generalApis/nameCreateGeneral";
import { primaryColor } from "../../utilities/colors";
import FormikSelect from "../Formik/FormikSelect";
import newCategoryFormValidationSchema from "../../utilities/Validation Schema/NewCategoryFormValidationSchema";
import Translator from "./Translator";
import SetTranslation from "./SetTranslations";
import Modal from "../Kanban/Modal/Modal";

const NewCategory = ({
  handleCloseModal,
  selectedRecord = {},
  refetchData,
  defaultEdit,
  setDefaultEdit,
}) => {
  const { sessionInfo = true } = useSession();
  const { company_id, context, user_id, isVTEX = false } = sessionInfo;

  const { language, translations } = useLanguage();
  const t = translations[language];

  const [isLoading, setIsLoading] = useState(true);

  const [publicCategoriesList, setPublicCategoriesList] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [modalType, setModalType] = useState("view");
  const [selectedMedia, setSelectedMedia] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [updatedData, setUpdatedData] = useState([]);

  const image1920Ref = useRef();
  const {
    options: stateList,
    setOptions: setStateList,
    handleCustomSearch,
  } = useListOptions();
  const { ConfirmationModal, toggleModal, setMetaData, setTitle } =
    useConfirmationModal();

  const { isSubmitting, setIsSubmitting, FormikSubmitButtons } =
    useFormikSubmitButton();

  const [storedInitialValues, setStoredInitialValues] = useState(() => {
    // Retrieve stored data from localStorage if it exists
    const savedData = localStorage.getItem("storedInitialValues");
    return savedData ? JSON.parse(savedData) : null;
  });

  const [formData, setFormData] = useState({
    name: "",
    parent_id: false,
    website_id: false,
    tax_id: false,
    image_1920: "",
    vtex_commission: "",
    vtexAdminId: false,
    global_category_id: false,
    vtex_description: "",
  });
  const modelName = "product.public.category";

  const handleChangeimage1920 = (e, setFieldValue) => {
    const file = e.target.files[0];
    if (file) {
      fileToBase64(file, (_, base64) => setFieldValue("image_1920", base64));
    }
    if (
      file &&
      !["image/png", "image/jpeg", "image/svg+xml"].includes(file.type)
    ) {
      alert("Unsupported file type. Please select a PNG, JPG, or SVG file.");
      return;
    }
  };
  const getPayload = (payload) => {
    return payload;
  };
  const handleAddCategory = async (values) => {
    const payload = getPayload(values);
    let response = await create({
      payload,
      context,
      company_id,
      model: modelName,
    });
    response = JSON.parse(response);
    if (response?.result) {
      handleCloseModal();
    }
    return response;
  };
  const handleEditForm = async (values) => {
    const newChanges = {};
    const oldPayload = getPayload(formData);
    const newPayload = getPayload(values);

    Object.keys(newPayload).forEach((key) => {
      if (JSON.stringify(newPayload[key]) !== JSON.stringify(oldPayload[key])) {
        newChanges[key] = newPayload[key];
      }
    });
    if (Object.keys(newChanges).length === 0) {
      handleCloseModal();
      return false;
    }
    let response = await write({
      id: selectedRecord?.id,
      change: newChanges,
      company_id,
      context,
      model: modelName,
    });
    response = JSON.parse(response);
    if (response?.result) {
      handleCloseModal();
      // refetchData();
    }
    return response;
  };

  const handleSubmitForm = async (...args) => {
    const [values, { setFieldError, setFieldTouched }] = args;

    setIsSubmitting(true);
    let response = {};
    let successMessage = "Category Created Successfully";

    if (modalType === "edit") {
      successMessage = "Category Edited Successfully";
      response = await handleEditForm(...args);
    } else if (modalType === "add") {
      response = await handleAddCategory(...args);
    }
    setIsSubmitting(false);
    handleResponse({
      response,
      setMetaData,
      setTitle,
      successMessage,
    });
    toggleModal();
  };

  const fetchCategoryDetails = async () => {
    let response = await read({
      id: selectedRecord.id,
      change: [
        "name",
        "parent_id",
        "website_id",
        "tax_id",
        "image_1920",
        "vtex_commission",
        "vtexAdminId",
        "global_category_id",
        "vtex_description",
      ],
      context,
      company_id,
      model: modelName,
    });
    response = JSON.parse(response);
    if (response?.result) {
      response = response?.result[0];
      // console.log("categ read resp", response);
      setFormData({
        ...response,
        parent_id: response?.parent_id?.[0],
        website_id: response?.website_id?.[0],
        tax_id: response?.tax_id?.[0],
      });
      setIsLoading(false);
      return response;
    }
  };

  const handleCreatePublicCategory = async (name) => {
    const response = await nameCreateGeneral({
      company_id,
      context,
      args: [name],
      model: modelName,
    });

    if (response.result) {
      const [value, label] = response?.result;
      findAndAddOption({
        incomingOption: [response?.result[0], name],
        setAvailableOptions: setPublicCategoriesList,
      });
      return { value, label };
    }
    return false;
  };
  const handleCreateTax = async (name) => {
    const response = await nameCreateGeneral({
      company_id,
      context,
      args: [name],
      model: "account.tax",
    });

    if (response.result) {
      const [value, label] = response?.result;
      findAndAddOption({
        incomingOption: [response?.result[0], name],
        setAvailableOptions: setPublicCategoriesList,
      });
      return { value, label };
    }
    return false;
  };

  useEffect(() => {
    if (selectedRecord?.id) {
      setModalType("view");
      fetchCategoryDetails().then((response) => {
        const parent_id = response.parent_id || "";
        const tax_id = response.tax_id || "";
        // console.log("parent_id,website_id", parent_id, website_id);
        findAndAddOption({
          incomingOption: parent_id ? parent_id : "",
          setAvailableOptions: setPublicCategoriesList,
        });
        findAndAddOption({
          incomingOption: tax_id ? tax_id : "",
          setAvailableOptions: setTaxList,
        });
      });
    } else {
      setModalType("add");
      handleCustomSearch({
        model: modelName,
        setState: setPublicCategoriesList,
      });
      handleCustomSearch({
        model: "account.tax",
        setState: setTaxList,
      });
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    if (modalType === "edit") {
      handleCustomSearch({
        model: modelName,
        setState: setPublicCategoriesList,
      });
      handleCustomSearch({
        model: "account.tax",
        setState: setTaxList,
      });
    }
  }, [modalType]);

  const disableInputs = useMemo(() => modalType === "view", [modalType]);
  return (
    <>
      <ConfirmationModal />
      {isCreateModalOpen && (
        <Modal isOpen={isCreateModalOpen} onClose={handleCloseModal}>
          <SetTranslation
            handleCloseModal={(modalValue) => setIsCreateModalOpen(false)}
            data={updatedData}
          />
        </Modal>
      )}
      <Formik
        enableReinitialize
        initialValues={formData}
        validationSchema={newCategoryFormValidationSchema}
        onSubmit={handleSubmitForm}
      >
        {({
          values,
          setFieldValue,
          validateForm,
          setErrors,
          setFieldTouched,
        }) => (
          <Form>
            <div
              className={`container ${modalType === "view" ? "mb-4" : ""}`}
              style={{ maxWidth: "1000px", padding: "10px" }}
            >
              <FormContainer className="row g-3">
                <div className="row p-0 justify-content-between align-items-center">
                  <div className="col">
                    <h3
                      className="me-2 mb-2 "
                      style={{
                        fontFamily: "Inter",
                        color: "#323B4B",
                        fontWeight: 600,
                      }}
                    >
                      {modalType === "add" && t["Add New Category"]}
                      {modalType === "edit" && t["Edit Category"]}
                      {modalType === "view" && t["Category"]}
                    </h3>
                  </div>
                  {modalType === "view" && (
                    <div className="col d-flex justify-content-end p-0">
                      <SVGButton
                        hoverColor={isVTEX ? primaryColor.primary : "#ff5837"}
                        icon={editIcon}
                        onClick={() => {
                          setModalType("edit");
                        }}
                        className="me-2"
                      />
                    </div>
                  )}
                </div>
                <LoaderWrapper
                  isLoading={isLoading}
                  height="70vh"
                  width="800px"
                >
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <div className="col-12 d-flex flex-md-row flex-column-reverse gap-3">
                      <div
                        className="col-md-6 col-12"
                        style={{ position: "relative" }}
                      >
                        {!disableInputs && (
                          <Translator
                            productId={selectedRecord?.id || ""}
                            modelSpecific={"product.public.category"}
                            color={primaryColor.primary}
                            fieldName={"name"}
                            fieldValue={values.name}
                            isCreateModalOpen={isCreateModalOpen}
                            setIsCreateModalOpen={setIsCreateModalOpen}
                            updatedData={updatedData}
                            setUpdatedData={setUpdatedData}
                          />
                        )}
                        <FormikInput
                          disabled={disableInputs}
                          name="name"
                          label={t["Name"]}
                        />
                      </div>
                      <div
                        className="col-6 product_image_container d-flex justify-content-center align-items-center mx-auto"
                        onClick={() => {
                          if (!disableInputs) image1920Ref.current.click();
                        }}
                      >
                        <UploadedImage src={values.image_1920 || cameraIcon} />
                        <input
                          ref={image1920Ref}
                          type="file"
                          name="image_1920"
                          hidden
                          accept="image/*"
                          onChange={(e) =>
                            handleChangeimage1920(e, setFieldValue)
                          }
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 col-12">
                        <FormikSelect
                          disabled={disableInputs}
                          options={publicCategoriesList}
                          label={t["Parent Category"]}
                          name="parent_id"
                          handleSearch={({ ...args }) => {
                            handleCustomSearch({
                              ...args,
                              model: modelName,
                            });
                          }}
                          handleCreate={handleCreatePublicCategory}
                          onChange={(op) => {
                            // console.log(op, "VtexBrand");
                            findAndAddOption({
                              incomingOption: [op.value, op.label],
                              setAvailableOptions: setPublicCategoriesList,
                            });
                          }}
                        />
                      </div>
                      <div className="col-md-6 col-12">
                        <FormikInput
                          disabled={disableInputs}
                          name="vtex_commission"
                          label={t["Commission"]}
                        />
                      </div>
                      <div className="col-md-6 col-12">
                        <FormikInput
                          disabled={disableInputs}
                          name="vtexAdminId"
                          label={t["VTEX Admin Id"]}
                        />
                      </div>
                      <div className="col-md-6 col-12">
                        <FormikInput
                          disabled={disableInputs}
                          name="global_category_id"
                          label={t["Global Category Id"]}
                        />
                      </div>
                      <div className="col-12">
                        <FormikInput
                          textArea
                          disabled={disableInputs}
                          name="vtex_description"
                          label={t["VTEX Description"]}
                        />
                      </div>
                    </div>
                  </div>

                  {/* <ErrorFocus /> */}

                  {!disableInputs && (
                    <FormikSubmitButtons handleCloseModal={handleCloseModal} />
                  )}
                </LoaderWrapper>
              </FormContainer>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default NewCategory;
